import { CARD_TYPE_MAP } from '../cardTypes';

const CARD_TYPES_WITH_ADDITIONAL_SHAPES = [
  CARD_TYPE_MAP.invitation,
  CARD_TYPE_MAP.std,
  CARD_TYPE_MAP.menu,
  CARD_TYPE_MAP.program,
  CARD_TYPE_MAP.holiday,
  CARD_TYPE_MAP.details,
  CARD_TYPE_MAP.enclosure,
  CARD_TYPE_MAP.rsvp,
  CARD_TYPE_MAP.weddingShower,
  CARD_TYPE_MAP.tableNumber,
] as const;

export type CardTypeWithAdditionalShapes = (typeof CARD_TYPES_WITH_ADDITIONAL_SHAPES)[number];

export const isCardTypeWithAdditionalShapes = (
  type?: string
): type is CardTypeWithAdditionalShapes => {
  if (!type) return false;
  return (CARD_TYPES_WITH_ADDITIONAL_SHAPES as Readonly<string[]>).includes(type);
};
